import Brief from "../../brief/Brief";
import LightPageLayout from "../../components/Page/LightPageLayout";

export default function ProcessPage() {
    return (
        <LightPageLayout>
            <Brief id="procedure-adoption" />
        </LightPageLayout>
    );
}
